import React, { Component } from 'react';
import { SketchPicker } from 'react-color';

import './colores.css'

import Functions from '../../../functions/Parametrizacion/handleColores';

class Colores extends Component {

    constructor(){
        super();
        this.state = {
            clase: '',
            backgroundBox: '',
            colorActivado: '',
            divAnterior: '',
            colorBot: '',
            colorCliente: '',
            colorBarra: '',
            colorFondo: '',
            textoSelect: '',
            colorTextoBot: '',
            colorTextoCli: '',
        }

        this.setearParametros();
        
    }
    
    setearParametros = async () => {
        const datos = await Functions.GetColoresDefinidos();
        if(datos){
            this.setState({
                colorBot: datos.data.color_bot,
                colorCliente: datos.data.color_cliente,
                colorBarra: datos.data.color_desplazamiento,
                colorFondo: datos.data.color_fondo,
                colorTextoBot: datos.data.color_texto_bot,
                colorTextoCli: datos.data.color_texto_cliente,
            });
        }else{
            console.log('no hay datos');
        }
    }
    
    cargarColores = () => {
        if(this.state.colorBarra){this.divColorBarra.style.backgroundColor = this.state.colorBarra;}
        if(this.state.colorBot){this.divColorChatbot.style.backgroundColor = this.state.colorBot;}
        if(this.state.colorCliente){this.divColorCliente.style.backgroundColor = this.state.colorCliente;}
        if(this.state.colorFondo){this.divColorFondo.style.backgroundColor = this.state.colorFondo;}

        if(this.state.colorTextoBot){
            let colorGuardado = this.state.colorTextoBot;
            switch (colorGuardado) {
                case '#ffffff':
                    document.getElementById('textoBlancoChatbot').classList.remove('colorNotSelect');
                    document.getElementById('textoBlancoChatbot').className = 'colorSelect';
                    break;

                case '#000000':
                    document.getElementById('textoNegroChatbot').classList.remove('colorNotSelect');
                    document.getElementById('textoNegroChatbot').className = 'colorSelect';
                    break;

                default:
                    break;
            }
        }
        
        if(this.state.colorTextoCli){
            let colorGuardado = this.state.colorTextoCli;
            switch (colorGuardado) {
                case '#ffffff':
                    document.getElementById('textoBlancoCliente').classList.remove('colorNotSelect');
                    document.getElementById('textoBlancoCliente').className = 'colorSelect';
                    break;

                case '#000000':
                    document.getElementById('textoNegroCliente').classList.remove('colorNotSelect');
                    document.getElementById('textoNegroCliente').className = 'colorSelect';
                    break;

                default:
                    break;
            }
        }
    }


    handleChangeComplete = async(color) => {     
        if(this.state.divAnterior){
            document.getElementById(this.state.divAnterior).style.backgroundColor = color.hex;
            
            switch (this.state.divAnterior) {
                case 'colorChatbot':
                        await this.setState({
                            colorBot: color.hex
                        });
                    break;
                case 'colorCliente':
                        await this.setState({
                            colorCliente: color.hex
                        });
                    break;
    
                case 'colorFondo':
                        await this.setState({
                            colorFondo: color.hex
                        });
                    break;
    
                case 'colorBarra':
                        await this.setState({
                            colorBarra: color.hex
                        });
                    break;
    
                default:
                    return 'No se actualizo el color';
                    
            }
            
            Functions.PostColoresDefinidos(this.state.divAnterior, color.hex); //base de datos
            this.props.enviarColores(this.state.divAnterior, color.hex); //vista previa

        }

    };

    activarColor = (e) => {
        let ident = e.target.id;

        if(this.state.divAnterior !== '' && ident !== this.state.divAnterior){
            document.getElementById(this.state.divAnterior).classList.remove('selecColor');
            document.getElementById(this.state.divAnterior).classList.add('notSelect');

            document.getElementById(ident).classList.remove('notSelect');
            document.getElementById(ident).classList.add('selecColor');

        }else{
            if(e.target.className !== 'selecColor'){
                if(this.state.divAnterior === 0){
                    document.getElementById(ident).classList.remove('notSelect');
                }
                document.getElementById(ident).classList.add('selecColor');
            }
        }
        this.setState({divAnterior: ident});
    }

    actTextBlanBot = (e) => {
        let elemento = e.target.id;
        if(elemento.className !== 'colorSelect'){
            document.getElementById(elemento).classList.remove("colorNotSelect");
            document.getElementById(elemento).className = "colorSelect";

            document.getElementById('textoNegroChatbot').classList.remove("colorSelect");
            document.getElementById('textoNegroChatbot').className = "colorNotSelect";

            this.setState({
                colorTextoBot: '#ffffff'
            });
        }
        Functions.PostColoresDefinidos('colorTextoBot', '#ffffff'); //base de datos
        this.props.enviarColores('colorTextoBot', '#ffffff'); //vista previa
    }

    actTextNegBot = async(e) => {
        let elemento = e.target.id;
        if(elemento.className !== 'colorSelect'){
            document.getElementById(elemento).classList.remove("colorNotSelect");
            document.getElementById(elemento).className = "colorSelect";

            document.getElementById('textoBlancoChatbot').classList.remove("colorSelect");
            document.getElementById('textoBlancoChatbot').className = "colorNotSelect";

            this.setState({
                colorTextoBot: '#000000'
            });
        }
        Functions.PostColoresDefinidos('colorTextoBot', '#000000'); //base de datos
        this.props.enviarColores('colorTextoBot', '#000000'); //vista previa
    }

    actTextBlancoCli = (e) => {
        let elemento = e.target.id;
        if(elemento.className !== 'colorSelect'){
            document.getElementById(elemento).classList.remove("colorNotSelect");
            document.getElementById(elemento).className = "colorSelect";

            document.getElementById('textoNegroCliente').classList.remove("colorSelect");
            document.getElementById('textoNegroCliente').className = "colorNotSelect";

            this.setState({
                colorTextoCli: '#ffffff'
            });
        }
        Functions.PostColoresDefinidos('colorTextoCli', '#ffffff'); //base de datos
        this.props.enviarColores('colorTextoCli', '#ffffff'); //vista previa
    }

    actTextNegroCli = (e) => {
        let elemento = e.target.id;
        if(elemento.className !== 'colorSelect'){
            document.getElementById(elemento).classList.remove("colorNotSelect");
            document.getElementById(elemento).className = "colorSelect";

            document.getElementById('textoBlancoCliente').classList.remove("colorSelect");
            document.getElementById('textoBlancoCliente').className = "colorNotSelect";

            this.setState({
                colorTextoCli: '#000000'
            });
        }
        Functions.PostColoresDefinidos('colorTextoCli', '#000000'); //base de datos
        this.props.enviarColores('colorTextoCli', '#000000'); //vista previa
    }

    render(){
        this.cargarColores();
        return(
            <div className='col s12 m4 x5'>
                <div className='row '>
                    <div className='col s12 m12 x12 headColores'>
                        <p>Colores</p>
                    </div>
                    <div className='col s12 m12 x12'>
                        <div className='row coloresChatbot'> 
                            {/* Mensajes del Chatbot */}
                            <div className='col m3 x3 colorChatbot'>
                                <p>Chatbot:</p>    
                                <div id='colorChatbot' onClick={this.activarColor} className='notSelect' ref={element => this.divColorChatbot = element}></div>
                            </div>
                            {/* Mensajes del cliente */}
                            <div className='col m4 x3 colorCliente'>
                                <p>Chats Cliente:</p>
                                <div id='colorCliente' onClick={this.activarColor} className='notSelect' ref={element => this.divColorCliente = element}></div>
                            </div>
                            {/* Color de la barra de desplazamiento */}
                            <div className='col m5 x3 colorBarra'>
                                <p>Barra desplazamiento:</p>    
                                <div id='colorBarra' onClick={this.activarColor} className='notSelect' ref={element => this.divColorBarra = element}></div>
                            </div>
                        </div>
                    </div>
                    <div className='col s12 m12 x12'>
                        <div className='row'> 
                            <div className='col m3 x3 textoChatbot'>
                                <p>Chatbot Texto:</p>    
                                <div onClick={this.actTextBlanBot} id='textoBlancoChatbot'  className='colorNotSelect'></div>
                                <div onClick={this.actTextNegBot} id='textoNegroChatbot' className='colorNotSelect'></div>
                            </div>
                            <div className='col m4 x3 textoCliente'>
                                <p>Chat cliente texto:</p>
                                <div onClick={this.actTextBlancoCli} id='textoBlancoCliente' className='colorNotSelect'></div>
                                <div onClick={this.actTextNegroCli} id='textoNegroCliente' className='colorNotSelect'></div>
                            </div>
                            {/* Fondo de la Caja del chat */}
                            <div className='col m5 x3 colorChatbox'>
                                <p>Color Fondo:</p>    
                                <div id='colorFondo' onClick={this.activarColor} className='notSelect' ref={element => this.divColorFondo = element}></div>
                            </div>
                        </div>
                    </div>
                    <div className='col s12 m12 x12'>
                        <div className='row'>
                            <div className='contenedorColores'>
                                <SketchPicker 
                                    color={ this.state.backgroundBox }
                                    onChangeComplete={ this.handleChangeComplete }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Colores;